import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    if (this.element.classList.contains("has_errors")) {
      $("#uploadPurchaseInvoiceModal").modal("show");
    }
  }
}
